export enum ExceptionEvent {
  ceLoginException = 'ce-login-exception',
  geTokenException = 'ge-token-exception',
}

export const getValueExceptionEvent: { [key in ExceptionEvent]: string } = {
  [ExceptionEvent.ceLoginException]: 'ce-login-exception',
  [ExceptionEvent.geTokenException]: 'ge-token-exception',
};
